<template>
  <mdb-container fluid>
    <div class="row pt-5 pb-3">
      <div class="col-md-3 mx-auto mb-4">
        <div class="card pt-0 card-cascade narrower">
          <div
            class="view view-cascade gradient-card-header mdb-color lighten-3"
          >
            <h5 class="mb-0 font-weight-bold">فیلتر</h5>
          </div>

          <div class="mt-2 card-body">
            <small>وضعیت ها:</small>

            <ul class="striped list-unstyled">
              <li class="hover filter" @click="filterInvoice(0)">
                <span class="badge bg-primary" v-text="countInvoice(0)"></span
                >&nbsp;
                <span>پرداخت نشده</span>
              </li>

              <li class="hover filter" @click="filterInvoice(1)">
                <span class="badge bg-primary" v-text="countInvoice(1)"></span
                >&nbsp;
                <span>پرداخت شده</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-md-8 mx-auto white z-depth-1 mb-4">
        <div class="row">
          <div class="col-sm-6 col-md-9 py-4 px-3">
            <h4 class="h4-responsive">فاکتورها</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 pb-3">
            <mdb-datatable
              ref="dataTable"
              :data="dataSet"
              bordered
              responsive
              autoWidth
              headerColor="elegant-color"
              headerWhite
              :tfoot="false"
              :hover="true"
              @selectRow="selectRow"
            />
          </div>
        </div>
      </div>
    </div>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbIcon,
  mdbInput,
  mdbTextarea,
  mdbBtn,
  mdbSelect,
  mdbFileInput,
  mdbChip,
  mdbDatatable,
} from "mdbvue";
import invoiceApi from "@/api/invoiceApi";

export default {
  name: "Support",
  components: {
    mdbContainer,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbInput,
    mdbTextarea,
    mdbBtn,
    mdbSelect,
    mdbFileInput,
    mdbChip,
    mdbDatatable,
  },
  data() {
    return {
      dataItem: [],
      columns: [
        {
          label: "شناسه اختصاصی",
          field: "InvoiceId",
          sort: "asc",
        },
        {
          label: "شماره",
          field: "Number",
          sort: "asc",
        },
        {
          label: "نام و توضیحات",
          field: "Name",
          sort: "asc",
        },
        {
          label: "مبلغ",
          field: "TotalPay",
          sort: "asc",
        },
        {
          label: "تاریخ ایجاد",
          field: "FirstUpdate",
          sort: "asc",
        },
        {
          label: "وضعیت",
          field: "PayStatusName",
          sort: "asc",
        },
      ],
      filterStatusPay: 0,
    };
  },
  methods: {
    showInvoice(invoice) {
      this.$router.push({
        name: "Invoice",
        params: { invoiceId: invoice.invoiceId },
      });
    },
    filterInvoice(payStatus) {
      this.filterStatusPay = payStatus;
    },
    countInvoice(payStatus) {
      // console.log("countInvoice",payStatus);
      return this.dataItem.filter((item) => {
        return item.PayStatus == payStatus;
      }).length;
    },
    selectRow(index,row){
      // console.log("selectRow",index,row);
      this.$router.push({name: 'Invoice', params: { invoiceId: row[0] }});
    }
  },
  mounted() {
    console.log("mounted");
    // this.paymentStatus = this.$store.state.paymentStatus;
    invoiceApi.getInvoices().then(
      ({ data }) => {
        this.dataItem = data.map(row => ({
                            ...row,
                            TotalPay: `${this.$options.filters.commaDigit(row.TotalPay)}`,
                          }));
      },
      (r) => {}
    );
  },
  computed: {
    dataSet() {
      return {
        columns: this.columns,
        rows: this.dataItem.filter((item) => {
          return item.PayStatus == this.filterStatusPay;
        }),
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1.1rem 1rem;
}

.card.card-cascade .view {
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2), 0 2px 8px 0 rgba(0, 0, 0, 0.19);
}
</style>
